import axios from 'axios'
import React, { useState, useEffect } from 'react'
import { Link, useHistory, useLocation } from 'react-router-dom'
import Swal from 'sweetalert2'
//import Rightcontainer from '../Components/Rightcontainer'
import '../css/layout.css'
import '../css/login.css'
import loginss from "./ss_ludo.jpg"
export default function Login() {

    const history = useHistory()


    const beckendLocalApiUrl = process.env.REACT_APP_BACKEND_LOCAL_API;
    const beckendLiveApiUrl = process.env.REACT_APP_BACKEND_LIVE_API;
    const nodeMode = process.env.NODE_ENV;
    if (nodeMode === "development") {
        var baseUrl = beckendLocalApiUrl;
    } else {
        baseUrl = beckendLiveApiUrl;
    }

    const [WebSitesettings, setWebsiteSettings] = useState("");

    const fetchData = async () => {
        const response = await fetch(baseUrl + "settings/data");
        const data = await response.json();
        return setWebsiteSettings(data);
    }
    //console.log(WebSitesettings);
    useEffect(() => {
        fetchData();
    },[])

    const [Phone, setPhone] = useState();
    const [twofactor_code, settwofactor_code] = useState();
    const [otp, setOtp] = useState(false)
    const [secretCode, setSecretCode] = useState();
    const [referral, setReferral] = useState(useLocation().pathname.split("/")[2])
    console.log("referral: ", referral)

    const handleClick = async (e) => {
        e.preventDefault();

        if (!Phone) {
            Swal.fire({
                icon: 'error',
                title: 'Oops...',
                text: 'Please enter your phone number',

            });

        }
        else if (Phone.length !== 10) {
            Swal.fire({
                icon: 'error',
                title: 'Oops...',
                text: 'Please  enter currect phone number',

            });
        }
        else {
            await axios.post(baseUrl + `login`, {
                Phone, referral
            }).then((respone) => {
                if (respone.data.status === 101) {
                    Swal.fire({
                        icon: 'error',
                        title: 'Oops...',
                        text: respone.data.msg,
                    })
                }
                else if (respone.data.status === 200) {
                    setOtp(true)
                    console.log(respone.data);
                    setSecretCode(respone.data.secret);
                    if (respone.data.myToken) {
                        Swal.fire({
                            icon: 'success',
                            title: 'OTP',
                            text: 'Demo Account Testing OTP: ' + respone.data.myToken,
                        })
                    }
                }
            })
                .catch((e) => {
                    Swal.fire({
                        icon: 'error',
                        title: 'Oops...',
                        text: 'Something went wrong',
                        // width: '20%',
                        // height:'20%',
                    })
                })
        }
    }


    const varifyOtp = async (e) => {
        e.preventDefault();
        
        console.log('verify otp sumbut req');
        if (!Phone) {
            Swal.fire({
                icon: 'error',
                title: 'Oops...',
                text: 'Please enter your phone number',

            })
        } else {
            await axios.post(baseUrl + `login/finish`, {
                Phone,
                twofactor_code,
                referral,
                secretCode
            }).then((respone) => {

                if (respone.data.status === 101) {
                    Swal.fire({
                        icon: 'error',
                        title: 'Oops...',
                        text: respone.data.msg,
                    })
                }
                else if (respone.data.status === 200) {

                    console.log('respone,',respone);
                    const token = respone.data.token
                    localStorage.setItem("token", token)
                    window.location.reload(true)
                    setTimeout(function () {
                        history.push("/Games")
                    }, 1000);

                }
                else {
                    Swal.fire({
                        icon: 'error',
                        title: 'Oops...',
                        text: 'Something went wrong!',
                    })
                }
            })
                .catch((e) => {
                    Swal.fire({
                        icon: 'error',
                        title: 'Oops...',
                        text: 'Something went wrong!',
                    })
                })
        }
    }

    const setError = () => {
        Swal.fire({
            icon: 'error',
            title: 'Oops...',
            text: 'Invalid Number',
            confirmation: true,
        })
    }
    return (
        <>
            <div className='leftContainer' style={{ minHeight: '100vh' }}>
                <div className="main-area" style={{background: '#000000'}}>
                    <div style={{ overflowY: 'hidden', padding: '0', margin: '0'}}>
                        {/* <div className="splash-overlay" /> */}
                        <div className="animate__bounce infinite divecho ">
                            <figure>
                                <img width="100%" src={loginss} alt="" />
                                </figure>
                        </div>



                        <div>
                            <div className="form_box position-absolute center-xy mx-auto" style={{ top: '10%', left: '6%', zIndex: 9, fontFamily: 'Poppins', padding: '2rem 0' }}>
                               
                                <div className="form_title d-flex text-white mb-4">Sign in</div>
                            
                                <div className="input_box cxy flex-column" style={{
                                     height: '60px', borderRadius: '5px', width: '100%'}}>
                                    <div className="input-group mb-2  " style={{ transition: 'top 0.5s ease 0s', top: '5px'}}>
                                        <div className="input-group-prepend">
                                            <div className="input-group-text" style={{backgroundColor: 'transparent', color: '#000051', border: 'none', fontFamily: 'Poppins', fontSize: '1.2rem'}}>+91</div>
                                        </div>
                                        <input className="form-control ravi" name="mobile" type="tel" placeholder="Mobile number"
                                            // onChange={(e) => setPhone(e.target.value)}
                                            onChange={(e) => {
                                                setPhone(e.target.value);
                                                if (e.target.value.length > 10) {
                                                    setError(true)
                                                }
                                            }}
                                            style={{ transition: 'all 3s ease-out 0s', border: 'none', fontFamily:'Poppins', fontSize: '1.2rem', background: 'transparent', backgroundColor: 'transparent'}}
                                        />
                                        {/* <div className="invalid-feedback">Enter a valid mobile number</div> */}
                                    </div>
                                </div>

                            

                                <div style={{transition: 'all 0.5s ease-out'}}>
                                {otp && <div>

                                    <div className="input-group mb-2" style={{ transition: 'all 0.5s ease-out', top: '5px'}}>


                                <div className='input_box cxy' style={{borderRadius: '5px', marginTop: '10px', marginInline: 'auto', width: '100%'}}>

                                        <div className="input-group-prepend">
                                            <div className="input-group-text" style={{backgroundColor: 'transparent', color: '#000051', border: 'none', fontFamily: 'Poppins', fontSize: '1.2rem', height: '60px' }}>OTP</div>
                                        </div>
                                        <input className="form-control" name="password" type="tel" placeholder="Enter OTP"
                                            onChange={(e) => settwofactor_code(e.target.value)}
                                            style={{ transition: 'all 0.5s ease-out', backgroundColor: 'transparent', border: 'none', background: 'transparent'}} />
                                </div>

                                    <div className="d-flex input_checked_box">    
                                        <input type="checkbox" name="terms" id="terms" onchange="activateButton(this)" />  
                                        <span style={{paddingLeft: "10px"}}>I  Agree Terms & Conditions</span>          
                                    </div>
                                        {/* <div className="invalid-feedback">Enter a valid mobile number</div> */}
                                    </div>

                            
    
                                </div>}
                                </div>
                            

                            

                                {!otp && <button className="Login-button cxy mt-4 bluebg" onClick={(e) => handleClick(e)} >Continue
                                </button>}
                                {otp && <button className="Login-button cxy mt-4" onClick={(e) => varifyOtp(e)} >Verify
                                </button>}



                                <div className="login-footer">By continuing I agree that {(WebSitesettings) ? WebSitesettings.CompanyName : ''}. may store and process my data in accordance with the <Link to="/term-condition">Terms of Use</Link>, <Link to="/PrivacyPolicy">Privacy Policy</Link> and that I am 18 years or older. I am not playing from
                                Assam, Odisha, Nagaland, Sikkim, Meghalaya, Andhra Pradesh, or Telangana.
                            </div>    

                            </div>
                           
                        </div>
                    </div>
                </div>

            </div>

        </>
    )
}